import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { Selection } from '../Common/selection';
import { fetchARAccounts, clearARAccounts } from '../../actions/arap_actions';

class AccountDropdown extends Component {

  state = {
    accountOptions: [],
  }

  componentDidMount() {
    this.props.clearARAccounts();
    this.props.fetchARAccounts();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.accountList && this.props.accountList !== nextProps.accountList) {
      this.setAccountOptions(nextProps.accountList);
    }
  }

  setAccountOptions(accounts) {
    const accountOptions = [];
    if (accounts) {
      accounts.map(account => {
        accountOptions.push({
          value: account.Account_id || account.id,
          label: account.Name || account.name,
        });
      });
    }
    this.setState({ accountOptions });
  }

  render() {
    if (this.props.accountsIsLoading && !this.props.accountsError) {
      return <Spinner />;
    } else if (this.props.accountsError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const { accountOptions } = this.state;
    return (
      <Field {...this.props} name='Account' component={Selection} options={accountOptions} />
    );
  }
}

/*
  arAccounts: {
    accountList,
    accountsIsLoading,
    accountsError,
  }
*/
function mapStateToProps(state) {
  return {
    ...state.arap.arAccounts,
  };
}

export default connect(mapStateToProps, {
  fetchARAccounts,
  clearARAccounts,
})(AccountDropdown);



// WEBPACK FOOTER //
// ./master/jsx/components/AR/accountDropdown.jsx